define(['modules/common/controls/control'], (Control) => Control.extend({

    tagName: 'div',

    binders: {
        remove (view, value) {
            if (!value) {
                view.removeErrors();
            }
        }
    }
}));
